var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall-video-player"},[_c('video',{ref:"player",attrs:{"src":_vm._f("replaceUrlProtocol")(_vm.src),"data-poster":_vm.poster,"playsinline":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }